import {Component, OnDestroy, OnInit, TemplateRef} from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CommonComponent} from '../shared/common/common.component';
import {NotificationsService} from '../../services/notifications.service';
import {CatalogsService} from '../../services/catalogs.service';
import {ToastaService} from 'ngx-toasta';
import {AccountService} from '../../services/account.service';
import {CustomerStatus} from '../../domain/customer/customer-detail';
import {mergeMap, takeUntil} from 'rxjs/operators';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {CustomerDetailService} from '../../services/customer-detail.service';
import {CustomerProfileService} from '../../services/customer-profile.service';
import {of, ReplaySubject} from 'rxjs';
import {ConfigurationService} from '../../services/configuration.service';
// import {DialogService} from 'primeng-lts/dynamicdialog';
import {DialogService} from 'primeng/dynamicdialog';
import {environment} from '../../../environments/environment';
import {StorageItem} from '../../enums/storage-item';
import {LocalStorageService} from 'angular-2-local-storage';
import {FamilyHealthService} from '../../services/family-health.service';
import {CountryCode} from '../../entity/CountryCodeEntity';
import {TitleCasePipe} from '@angular/common';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends CommonComponent implements OnInit, OnDestroy {
  email: string = null;
  phone: string = null;
  password: string;
  phoneCountryCode: string = null;
  showPassword: boolean = false;
  phoneField = true;
  emailField = false;
  cardActivation = false;
  welcomeName: string;
  isPasswordInvalid = false;
  countryCodes: CountryCode[] = [];
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  isDropdownOpen = false;
  selectedCountryCode: { dialCode: string; name: string } | null = null;
  constructor(
    public translate: TranslateService,
    private catalogsService: CatalogsService,
    private authenticationService: AuthenticationService,
    private accountsService: AccountService,
    public configurationService: ConfigurationService,
    private customerDetailService: CustomerDetailService,
    private customerProfileService: CustomerProfileService,
    private localStorage: LocalStorageService,
    protected router: Router,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected dialogService: DialogService,
    protected familyHealthService: FamilyHealthService,
    private titlecasePipe: TitleCasePipe
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.countryCodes = this.countryCodeCatalog(this.configurationService.application);
      });
  }

  ngOnInit(): void {

    scrollTo(0, 0);
    const storedCountryCode: string = this.localStorage.get(StorageItem.COUNTRY_CODE);

    if(this.configurationService.home.pronounsWelcome){
      this.welcomeName = `${this.titlecasePipe.transform(this.localStorage.get(StorageItem.USER_INFORMATION) || '')}`;
    }else{
      this.welcomeName = `${this.localStorage.get(StorageItem.TITLE) || ''} ${this.titlecasePipe.transform(this.localStorage.get(StorageItem.USER_INFORMATION) || '')}`;
    }

    this.phoneCountryCode = storedCountryCode ? storedCountryCode : '1';
    if (this.authenticationService.isAuthenticated()) {
      this.router.navigate(['account/balance']);
    } else {
      this.customerDetailService.clearCustomerDetal();
      this.customerProfileService.clearCustomerProfile();
      this.configurationService.getPlatformConfigService().subscribe(
        (response: any) => {
          this.countryCodes = this.countryCodeCatalog(this.configurationService.application);
        }
      );
    }
  }

  login() {
    let username: string;
    if (this.email != null) {
      username = this.email;
    }
    if (this.phone != null) {
      username = `${this.phoneCountryCode}${this.phone}`;
      this.localStorage.set(StorageItem.COUNTRY_CODE, this.phoneCountryCode);
    }
    this.loadingModalOn();
    this.authenticationService.login(username, this.password).subscribe(
      response => {
        this.toastService.clearAll();
        this.getCustomerProfile();
      }, error => {
        this.msgError(error);
        this.isPasswordInvalid = error.status === 401;
        this.loadingModalOff();
      }
    );
  }

  openModal(content: TemplateRef<any>): void {
    this.modalService.open(content, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  getCustomerProfile() {
    this.customerProfileService.getInstance();
    this.customerProfileService.customerProfile$.pipe(takeUntil(this.destroyed$)).subscribe(
      (response: any) => {

        if (environment.production && window.location.pathname.substring(1, 3) !== response.language) {
          window.location.replace(`${window.location.protocol}//${window.location.host}/${response.language}/${window.location.pathname.substring(4)}${window.location.search}`);
        }
        this.translate.use(this.getValidLanguage(response.language));
        if (response.customerStatus === CustomerStatus.ACTIVE) {
          this.familyHealthService.status = response.healthSubscriptionStatus;
          if (this.configurationService.account.enableFamilyHealth){
            this.familyHealthService.getFamilyHealthUrl();
          }
        }
        this.loadingModalOff();
        this.router.navigate(['account/balance']);
      },
      error => {
        this.authenticationService.logout();
        this.loadingModalOff();
        this.msgError(error);
      }
    );
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.unsubscribe();
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectCountry(country: { dialCode: string; name: string }): void {
    this.phoneCountryCode = country.dialCode;
    this.localStorage.set(StorageItem.COUNTRY_CODE, this.phoneCountryCode);
    this.selectedCountryCode = country;
    this.isDropdownOpen = false;
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  handleBlurPassword(): void {
    setTimeout(() => {
      this.showPassword = false;
    }, 100);
  }
}
